module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media"
  }, [(_vm.imageLink) ? _c('router-link', {
    attrs: {
      "to": _vm.imageLink
    }
  }, [_c('div', {
    staticClass: "media__image",
    class: {
      round: _vm.imageRounded
    },
    style: (("background-image: url(" + _vm.image + ")"))
  })]) : _c('div', {
    staticClass: "media__image",
    class: {
      round: _vm.imageRounded
    },
    style: (("background-image: url(" + _vm.image + ")"))
  }), _vm._v(" "), _c('div', {
    staticClass: "media__content"
  }, [_c('div', [(_vm.titleLink) ? _c('router-link', {
    attrs: {
      "to": _vm.titleLink
    }
  }, [_c('div', {
    staticClass: "media__title"
  }, [_vm._v("\n          " + _vm._s(_vm.title) + "\n          "), (_vm.meta.verified) ? _c('v-icon', [_vm._v("fa-check-circle")]) : _vm._e()], 1)]) : _c('div', {
    staticClass: "media__title"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n        "), (_vm.meta.verified) ? _c('v-icon', [_vm._v("fa-check-circle")]) : _vm._e()], 1), _vm._v(" "), (_vm.subtitle) ? _c('div', {
    staticClass: "media__subtitle"
  }, [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e(), _vm._v(" "), (_vm.description) ? _c('div', {
    staticClass: "media__description"
  }, [_vm._v("\n        " + _vm._s(_vm.description) + "\n      ")]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-428e6a46","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/app_card.vue
// module id = 1700
// module chunks = 180